import {
	GridChildOneStyles,
	ImportCSVTextContainer,
	SupportedFilesTextSize,
	UnsetSecondaryCopy
} from "../NewOrders.styles";
import { Button } from "@mui/material";
import {
	CreateYourItemText,
	CSVText,
	DownloadLatestText,
	HereText,
	ImportCSVText,
	ImportFileText,
	SupportedFilesText
} from "constants/text";
import Link from "@mui/material/Link";
import UploadIcon from "@mui/icons-material/Upload";
import { salesforceBaseURL } from "constants/endpoints";
import { useDispatch } from "react-redux";
import { DialogTracking } from "components/Dialog/components/DialogTracking.ts";
import { OrderType } from "types/declarations/enums.ts";
import { newOrderActions } from "features/reducers/newOrder/newOrder";
import { useDialog } from "hooks/useDialog.ts";

interface ImportCSVProps {
	isAddOn?: boolean;
	isLandingPage?: boolean;
	isNewQuoteOrder?: boolean;
}

const ImportCSV = ({ isAddOn = false, isLandingPage, isNewQuoteOrder }: ImportCSVProps) => {
	const dispatch = useDispatch();
	const { openDialog } = useDialog();
	const handleImportFile = () => {
		if (isAddOn) {
			dispatch(newOrderActions.updateOrderType(OrderType.ADD_ON));
		} else if (isNewQuoteOrder) {
			dispatch(newOrderActions.updateOrderType(OrderType.QUOTE_ORDER));
		} else {
			dispatch(newOrderActions.updateOrderType(OrderType.ORIGINAL));
		}
		openDialog({ dialogStatus: DialogTracking.CSV_UPLOAD });
	};

	return (
		<GridChildOneStyles
			isAddOn={isAddOn}
			isLandingPage={isLandingPage}
		>
			<ImportCSVTextContainer>{ImportCSVText}</ImportCSVTextContainer>
			<span>{CreateYourItemText}</span>
			<SupportedFilesTextSize>
				{SupportedFilesText}
				<b>{CSVText}</b>
			</SupportedFilesTextSize>
			<Button
				onClick={handleImportFile}
				fullWidth
				variant={isAddOn ? "outlined" : "contained"}
				startIcon={<UploadIcon sx={{ marginBottom: "3px" }} />}
				data-id={`${isAddOn ? "add-ons" : "new-order"}-landing-page-import-button`}
			>
				{ImportFileText}
			</Button>

			<UnsetSecondaryCopy>
				{DownloadLatestText}{" "}
				<Link
					href={`${salesforceBaseURL}/s/design-software`}
					data-testid="newOrder-download-latest-catalogs"
				>
					{HereText}
				</Link>
			</UnsetSecondaryCopy>
		</GridChildOneStyles>
	);
};

export default ImportCSV;
